module.exports = __webpack_public_path__ + "assets/img/btn-view-3e7028c2.png";